/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import moment from 'moment'
import { withRouter, Link } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import { Row, Col, Empty, Skeleton } from 'antd'
// import Clock from 'react-live-clock'
import { compose } from 'recompose'
import _ from 'lodash'
import { loadScripts } from './scripts'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import { RoleCode } from '../../../constants'

import Counts from './components/counts'
import ChartGender from './components/chartGender'
import ChartCivilStatus from './components/chartCivilStatus'
import SchoolType from './components/schooltypeChart'
import ResidencyType from './components/chartResidencyType'
import HouseholdDesignation from './components/chartHouseholdDesignation'
import EducationalAttainment from './components/chartEducAttainment'
import YearLevel from './components/chartYearLevel'
import DisabilityType from './components/chartDisabilityType'
import Occupations from './components/chartOccupations'
import Industry from './components/chartIndustry'
import Classworker from './components/chartClassworker'
import NatureEmployment from './components/chartNatureEmployment'
import NotApplyingJob from './components/chartNotApplyingjob'
import ExperiencedCrime from './components/chartCrimes'
import Constituents from './components/chartConstituents'
import Purok from './components/chartPurok'
import Nutrition from './components/chartNutrition'
import Voters from './components/chartVoters'
// import Certificates from './components/chartCertificates'
import Household from './components/chartHousehold'
import Illness from './components/chartIllness'
import Poorest from './components/chartPoorest'
import Religion from './components/chartReligion'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			showMore: false
		}
	}

	componentDidMount() {
		const { AuthStore } = this.props
		const { user_type } = AuthStore
		if (_.isEqual(user_type, RoleCode.MEDICALPERSONNEL)) {
			window.location.href = '/medical'
		}
		loadScripts()
	}

	render() {
		const { showMore } = this.state
		const { AuthStore } = this.props
		const { barangay_uid, user_type } = AuthStore

		const isAdmin = (_.isEqual(user_type, RoleCode.SYSTEMADMIN) || _.isEqual(user_type, RoleCode.SUPERADMIN))
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item active">Dashboard</li>
								</ol>
							</div>
							<h4 className="page-title">Dashboard</h4>
						</div>
					</div>
				</div>
				<Query
					query={SYSTEM_DASHBOARD}
					variables={{ barangay_uid }}
					fetchPolicy='network-only'
				>
					{({ loading, error, data }) => {
						if (error) return <Empty />
						if (loading) return <Skeleton active />

						const dashboardData = _.has(data, 'systemDashboard') ? data.systemDashboard : {}
						console.log('dashboardData', dashboardData)
						return (
							<div className="row">
								<Counts dashboardData={dashboardData}/>
								<Household dashboardData={dashboardData}/>
								<Constituents dashboardData={dashboardData}/>
								<ChartCivilStatus dashboardData={dashboardData} />
								<ResidencyType dashboardData={dashboardData} />
								<ChartGender dashboardData={dashboardData} />
								<Religion dashboardData={dashboardData} />
								<Nutrition dashboardData={dashboardData} />
								<Voters dashboardData={dashboardData} />
								{
									!showMore && 
									<Col md={24} sm={24} style={{ textAlign: 'center' }}>
										<a href='javascript:void(0)' style={{ marginTop: 10, marginBottom: 10 }} onClick={() => {
											this.setState({ showMore: true })
										}}>.... Show More</a>
									</Col>
								}
								{
									showMore &&
									<React.Fragment>
										<SchoolType dashboardData={dashboardData} />
										<HouseholdDesignation dashboardData={dashboardData} />
										<NatureEmployment dashboardData={dashboardData} />
										<Classworker dashboardData={dashboardData} />
										<YearLevel dashboardData={dashboardData} />
										<Purok dashboardData={dashboardData}/>
										<Illness dashboardData={dashboardData} />
										<EducationalAttainment dashboardData={dashboardData} />
										<Occupations dashboardData={dashboardData} />
										<Industry dashboardData={dashboardData} />
										<DisabilityType dashboardData={dashboardData} />
										{/* <Certificates dashboardData={dashboardData} /> */}
										<NotApplyingJob dashboardData={dashboardData} />
										<ExperiencedCrime dashboardData={dashboardData} />
										<Poorest dashboardData={dashboardData} />
									</React.Fragment>
								}
								{
									showMore && 
									<Col md={24} sm={24} style={{ textAlign: 'center' }}>
										<a href='javascript:void(0)' style={{ marginTop: 10, marginBottom: 10 }} onClick={() => {
											this.setState({ showMore: false })
										}}>Show Less ....</a>
									</Col>
								}
							</div>
						)
					}}
				</Query>
			</React.Fragment>
		)
	}
}

const SYSTEM_DASHBOARD = gql`
    query systemDashboard($barangay_uid: String) {
		systemDashboard(barangay_uid: $barangay_uid)
    }
`

const composed = compose(
	inject('AuthStore'),
	withRouter,
	observer
)

export default composed(Index)
